import React from 'react'
import styles from './QuickJoinButton.module.css'
import { FaChevronRight } from 'react-icons/fa'
import { BsLightningCharge } from "react-icons/bs";
import useCreateGame from '@/src/hooks/utils/useCreateGame';
import useGameDefinition from '@/src/hooks/data/useGameDefinition';
import usePlayerBalance from '@/src/hooks/data/usePlayerBalance';
import { useDispatch } from 'react-redux';
import { showBuyInPopupInLobby } from '@/Poker/redux/slices/lobbySlice';

export default function QuickJoinButton({ gameDefId, minBuyInAmount }) {
    const dispatch = useDispatch();
    const { initiateCreateTable } = useCreateGame();
    const gameDefinition = useGameDefinition(gameDefId);
    const playerBalance = usePlayerBalance();


    if (!gameDefId || !gameDefinition) {
        return null;
    }

    const handleQuickJoin = () => {
        if (playerBalance.totalBalance < minBuyInAmount) {
            dispatch(showBuyInPopupInLobby({ gameDefinition }));
            return;
        }
        initiateCreateTable(gameDefinition, null, false, true);
    }

    return (
        <div onClick={handleQuickJoin} className={styles.quickJoinButton}>
            {/* Lightnightg Icon from React-Icons */}
            <BsLightningCharge color='var(--color-h-primary)' size={16} />
            Quick Join
            {/* Right Chevron from React-Icons */}
            <FaChevronRight color='var(--color-h-primary)' size={10} />
        </div>
    )
}
